import * as Common from 'components/common/Common'
import { useAppSelector } from 'hooks/useRedux'
import { ReactNode, useRef } from 'react'
import { createPortal } from 'react-dom'
import { selectFitCustomResolution } from 'redux/slices/app'
import { useOnClickOutside } from 'shared-ui'
import styled, { css } from 'styled-components'
import { ICommonModalProps } from 'types/common'

interface IModalLargeProps extends ICommonModalProps {
  children: ReactNode
  className?: string
  closeOnClickOutside?: boolean
  variant: 'full' | 'action'
  bottomChildren?: ReactNode
  bgSrc: string
}

export const ModalWideBody = styled(Common.Div)(
  ({ theme: { colors, isKiosk, params } }) => css`
    background: ${colors.modalBackground};
    border-radius: ${params.buttonBorderRadius};
    border: none;
    bottom: auto;
    box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
    height: 546px;
    left: 50%;
    margin-right: -50%;
    max-height: 90vh;
    min-height: 50vh;
    min-width: 50vw;
    overflow: auto;
    padding: 12px;
    position: absolute;
    right: auto;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 924px;
    z-index: 9999;

    &::-webkit-scrollbar {
      /* Hide the scrollbar */
      display: none;
    }

    /* ${isKiosk &&
    css`
      border-radius: 0;
      top: 111px;
      left: 50px;

      transform: translate(0, 0);
    `} */
  `
)

type BackgroundProps = { bgSrc: string; variant: 'full' | 'action' }

export const Background = styled(Common.Div)<BackgroundProps>(
  ({ bgSrc, variant, theme: { params } }) => css`
    width: 100%;
    height: ${variant === 'full' ? '100%' : '399px'};
    background: url(${bgSrc});
    border-radius: ${params.buttonBorderRadius};
  `
)

export const ModalOverlay = styled.div(
  ({ theme: { colors } }) => css`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: ${colors.modalOverlay};
    z-index: 999;
  `
)

const ModalLarge = ({
  isOpen,
  setIsOpen,
  children,
  className,
  closeOnClickOutside = true,
  variant = 'full',
  bottomChildren,
  bgSrc,
}: IModalLargeProps) => {
  const isMobile = useAppSelector(state =>
    selectFitCustomResolution(state, 926)
  )

  const modalRef = useRef(null)

  if (closeOnClickOutside) {
    useOnClickOutside(modalRef, () => {
      setIsOpen(false)
    })
  }

  return isOpen
    ? createPortal(
        <>
          <ModalOverlay />
          <ModalWideBody
            ref={modalRef}
            className={className}
            isMobile={isMobile}
          >
            {variant === 'full' && (
              <Background
                bgSrc={bgSrc}
                variant="full"
              >
                {children}
              </Background>
            )}
            {variant === 'action' && (
              <>
                <Background
                  bgSrc={bgSrc}
                  variant="action"
                >
                  {children}
                </Background>
                {bottomChildren}
              </>
            )}
          </ModalWideBody>
        </>,
        document.body
      )
    : null
}

export default ModalLarge
